import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { isValidElement as $hgUW1$isValidElement, createElement as $hgUW1$createElement, Component as $hgUW1$Component, createContext as $hgUW1$createContext, useContext as $hgUW1$useContext, useState as $hgUW1$useState, useMemo as $hgUW1$useMemo, forwardRef as $hgUW1$forwardRef } from "react";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $44d7e150ebc754d2$exports = {};
$parcel$export($44d7e150ebc754d2$exports, "ErrorBoundary", function () {
  return $44d7e150ebc754d2$export$e926676385687eaf;
});
var $ebb31c7feaa4405e$exports = {};
$parcel$export($ebb31c7feaa4405e$exports, "ErrorBoundaryContext", function () {
  return $ebb31c7feaa4405e$export$b16d9fb1a22de840;
});
var $ebb31c7feaa4405e$export$b16d9fb1a22de840 = (0, $hgUW1$createContext)(null);
var $44d7e150ebc754d2$var$initialState = {
  didCatch: false,
  error: null
};

var $44d7e150ebc754d2$export$e926676385687eaf = /*#__PURE__*/function (_ref) {
  _inherits($44d7e150ebc754d2$export$e926676385687eaf, _ref);

  var _super = _createSuper($44d7e150ebc754d2$export$e926676385687eaf);

  function $44d7e150ebc754d2$export$e926676385687eaf() {
    var _this;

    _classCallCheck(this, $44d7e150ebc754d2$export$e926676385687eaf);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "state", $44d7e150ebc754d2$var$initialState);

    _defineProperty(_assertThisInitialized(_this), "resetErrorBoundary", function () {
      var error = _this.state.error;

      if (error !== null) {
        var _this$props$onReset, _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        (_this$props$onReset = (_this$props = _this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props, {
          args: args,
          reason: "imperative-api"
        });

        _this.setState($44d7e150ebc754d2$var$initialState);
      }
    });

    return _this;
  }

  _createClass($44d7e150ebc754d2$export$e926676385687eaf, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props2, error, info);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var didCatch = this.state.didCatch;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
      // we'd end up resetting the error boundary immediately.
      // This would likely trigger a second error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.

      if (didCatch && prevState.error !== null && $44d7e150ebc754d2$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
        var _this$props$onReset2, _this$props3;

        (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 ? void 0 : _this$props$onReset2.call(_this$props3, {
          next: resetKeys,
          prev: prevProps.resetKeys,
          reason: "keys"
        });
        this.setState($44d7e150ebc754d2$var$initialState);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;
      var _this$state = this.state,
          didCatch = _this$state.didCatch,
          error = _this$state.error;
      var childToRender = children;

      if (didCatch) {
        var props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };
        if ((0, $hgUW1$isValidElement)(fallback)) childToRender = fallback;else if (typeof fallbackRender === "function") childToRender = fallbackRender(props);else if (FallbackComponent) childToRender = (0, $hgUW1$createElement)(FallbackComponent, props);else throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
      }

      return (0, $hgUW1$createElement)((0, $ebb31c7feaa4405e$export$b16d9fb1a22de840).Provider, {
        value: {
          didCatch: didCatch,
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        }
      }, childToRender);
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        didCatch: true,
        error: error
      };
    }
  }]);

  return $44d7e150ebc754d2$export$e926676385687eaf;
}((0, $hgUW1$Component));

function $44d7e150ebc754d2$var$hasArrayChanged() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return a.length !== b.length || a.some(function (item, index) {
    return !Object.is(item, b[index]);
  });
}

var $7c3c25b3f398a9d6$exports = {};
$parcel$export($7c3c25b3f398a9d6$exports, "useErrorBoundary", function () {
  return $7c3c25b3f398a9d6$export$c052f6604b7d51fe;
});

function $75c9d331f9c1ed1a$export$f20aa86254872370(value) {
  if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
  return true;
}

function $7c3c25b3f398a9d6$export$c052f6604b7d51fe() {
  var context = (0, $hgUW1$useContext)((0, $ebb31c7feaa4405e$export$b16d9fb1a22de840));
  (0, $75c9d331f9c1ed1a$export$f20aa86254872370)(context);

  var _ref2 = (0, $hgUW1$useState)({
    error: null,
    hasError: false
  }),
      _ref3 = _slicedToArray(_ref2, 2),
      state = _ref3[0],
      setState = _ref3[1];

  var memoized = (0, $hgUW1$useMemo)(function () {
    return {
      resetBoundary: function resetBoundary() {
        context === null || context === void 0 ? void 0 : context.resetErrorBoundary();
        setState({
          error: null,
          hasError: false
        });
      },
      showBoundary: function showBoundary(error) {
        return setState({
          error: error,
          hasError: true
        });
      }
    };
  }, [context === null || context === void 0 ? void 0 : context.resetErrorBoundary]);
  if (state.hasError) throw state.error;
  return memoized;
}

var $62ff477d53f02a5b$exports = {};
$parcel$export($62ff477d53f02a5b$exports, "withErrorBoundary", function () {
  return $62ff477d53f02a5b$export$f0c7a449e0cfaec7;
});

function $62ff477d53f02a5b$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
  var Wrapped = (0, $hgUW1$forwardRef)(function (props, ref) {
    return (0, $hgUW1$createElement)((0, $44d7e150ebc754d2$export$e926676385687eaf), errorBoundaryProps, (0, $hgUW1$createElement)(component, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    })));
  }); // Format for display in DevTools

  var name = component.displayName || component.name || "Unknown";
  Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
  return Wrapped;
}

var $81c1b644006d48ec$exports = {};
"use client";
export { $44d7e150ebc754d2$export$e926676385687eaf as ErrorBoundary, $ebb31c7feaa4405e$export$b16d9fb1a22de840 as ErrorBoundaryContext, $7c3c25b3f398a9d6$export$c052f6604b7d51fe as useErrorBoundary, $62ff477d53f02a5b$export$f0c7a449e0cfaec7 as withErrorBoundary };